import React from 'react'
import qs from 'qs'
import { get, isEmpty, omit } from 'lodash'
import { Navigate as Redirect } from 'react-router'
import IndexComponent from '../common/IndexComponent'
import withRouter from '../../lib/withRouter'
import indexActions from '../../actions/MedicareAdvantageBenefitsSets'
import { BenefitsSetIndex } from '../BenefitsSet/BenefitsSetIndex'
import approvalStateDisplay from '../BenefitsSet/approvalStateDisplay'
import publishStateDisplayWithModal from '../BenefitsSet/publishStateDisplayWithModal'
import Component from '../common/Component'
import connectIndex from '../../lib/connectIndex'
import exportActions from '../../actions/BenefitsSetsExports'
import exportCsvActions from '../../actions/BenefitsSetCsvExports'
import BulkPublishLink from '../BenefitsSet/BulkPublishLink'
import BenefitsSetsHelper from '../BenefitsSet/Helpers/BenefitsSetsHelper'
import BulkApproveLink from '../BenefitsSet/BulkApproveLink'

export class MedicareAdvantageBenefitsSetIndex extends Component {
  static propTypes = {
    ...omit(BenefitsSetIndex.propTypes, 'productLine')
  }

  get bulkPublishButton() {
    const planCount = get(this.props.pagination, 'total', 0)

    if (planCount === 0 || isEmpty(this.queryParams)) {
      return null
    }

    return (
      <BulkPublishLink
        key="bulk-publish-link"
        planCount={planCount}
        queryParams={this.queryParams}
        productLine="medicare_advantage"
      />
    )
  }

  get bulkApproveAllButton() {
    const planCount = get(this.props.pagination, 'total', 0)

    if (planCount === 0 || isEmpty(this.queryParams)) {
      return null
    }

    return (
      <BulkApproveLink
        key="bulk-approve-link"
        planCount={planCount}
        queryParams={this.queryParams}
        termValidated="document_id"
        productLine="medicare_advantage"
      />
    )
  }

  get queryParams() {
    return qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
  }

  render() {
    const { benefitsSetCsvExport } = this.props
    if (benefitsSetCsvExport && benefitsSetCsvExport.created) {
      return (
        <Redirect
          push
          to={{ pathname: '/benefits_set_csv_exports' }}
        />
      )
    }

    return (
      <div>
        <BenefitsSetIndex
          {...this.props}
          name="Medicare Advantage Benefits Set"
          columnsList={columnsList}
          includeBulkEditLink
          includeDiffSetLink
          includeSelectAll
          includeNewRecordLink={false}
          searchPlaceholder="Search by Name, Contract ID, Vericred ID, or Issuer ID"
          actionLinks={[this.bulkPublishButton, this.bulkApproveAllButton]}
          productLine="medicare_advantage"
        />
      </div>
    )
  }
}

const columnsList = [
  { key: 'name', label: 'Name', display: BenefitsSetIndex.showLinkDisplay('/med_adv_benefits') },
  { key: 'issuer_name', label: 'Issuer' },
  { key: 'issuer_id', label: 'Issuer ID' },
  { key: 'vericred_id', label: 'Vericred ID', sortable: false },
  { key: 'medicare_plan_id', label: 'Contract ID', sortable: false },
  { key: 'updated_at', label: 'Last Updated At', display: IndexComponent.dateTimeDisplay },
  { key: 'last_updated_by_username', label: 'Last Updated By' },
  {
    key: 'plan_year',
    label: 'Year',
    sortable: false,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'approval_state',
    label: 'Status',
    display: approvalStateDisplay,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'publish_state',
    label: 'Publish Status',
    display: publishStateDisplayWithModal,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'networks',
    label: 'Networks',
    display: BenefitsSetIndex.networksDisplay,
    filterable: true,
    sortable: false,
    recordLabel: 'text',
    recordValue: 'value'
  }
]

const filters = [
  {
    key: 'plan_year',
    options: BenefitsSetsHelper.planYearOptions(2015, (new Date()).getFullYear() + 1)
  },
  {
    key: 'approval_state',
    options: [
      { value: 'new', text: 'New' },
      { value: 'approved', text: 'Approved' },
      { value: 'rejected', text: 'Rejected' },
      { value: 'corrected', text: 'Corrected' },
      { value: 'amended', text: 'Amended' }
    ]
  },
  {
    key: 'publish_state',
    options: [
      { value: 'needs_publishing', text: 'Needs Publishing' },
      { value: 'failed_to_publish', text: 'Failed to publish' },
      { value: 'published', text: 'Published' },
      { value: 'unpublished', text: 'Unpublished' },
      { value: 'publishing', text: 'Publishing' }
    ]
  },
  {
    key: 'networks',
    options: [
      { value: 'true', text: 'Mapped' },
      { value: 'false', text: 'Not Mapped' }
    ]
  }
]

export default connectIndex(
  withRouter(MedicareAdvantageBenefitsSetIndex),
  'medicareAdvantageBenefitsSets',
  indexActions,
  filters,
  {
    benefitsSetPath: '/med_adv_benefits',
    includeCsvExportLink: true,
    searchColumns: ['name', 'issuer_id', 'vericred_id', 'contract_id']
  },
  [
    { action: exportActions.create.main, key: 'createBenefitsSetExport' },
    { action: exportActions.create.reset, key: 'resetCreateBenefitsSetExport' },
    { action: exportCsvActions.create.main, key: 'createBenefitsSetCsvExport' },
    { action: exportCsvActions.create.reset, key: 'resetCreateBenefitsSetCsvExport' }
  ],
  [
    { key: 'benefitsSetExport', reducer: 'benefitsSetsExports', action: 'create' },
    { key: 'benefitsSetCsvExport', reducer: 'benefitsSetCsvExports', action: 'create' }
  ]
)
